// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingSpinnerWrapper_wrapper__Y0TVf","spinner":"LoadingSpinnerWrapper_spinner__kYfJH","lds-ring":"LoadingSpinnerWrapper_lds-ring__uiSNW"};